<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-20">
          <div class="flex">
            <div-title
              v-if="this.modalAction === 'add'"
              class="w-4/5 text-left px-3 pb-3 text-2xl font-bold"
              :colorP="colorP"
            >
              Nuevo Proyecto
            </div-title>
            <div-title
              v-if="this.modalAction === 'edit'"
              class="w-4/5 text-left px-3 pb-3 text-2xl font-bold"
              :colorP="colorP"
            >
              Actualización del Proyecto
            </div-title>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <!-- <div
          v-if="this.modalAction === 'add'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >
          Nuevo Proyecto
        </div>
        <div
          v-if="this.modalAction === 'edit'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >
          Actualización del Proyecto
        </div>
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div> -->
        <div class="flex flex-col items-center">
          <form class="w-full px-4" id="proyectForm" @submit.prevent>
            <div class="flex flex-wrap items-center justify-around -mx-3 mb-6">
              <div class="px-3 mb-6 md:mb-0 flex flex-col justify-center">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="image"
                  >Imagen</label
                >
                <div class="relative h-60 w-80 bg-gray-200">
                  <img
                    :src="imageURL"
                    class="h-full w-full object-cover"
                    alt
                    @error="loadDefaultImg"
                  />
                  <div
                    class="absolute cursor-pointer right-0 bottom-0 flex items-center justify-center p-2 rounded-full border-4 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 fill-current"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                      />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                    <input
                      @change="changeImage"
                      class="cursor-pointer bottom-0 right-0 w-10 h-10 absolute block opacity-0"
                      type="file"
                      ref="image"
                      name="image"
                      accept="image/png, image/jpeg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="name"
                  >Nombre del proyecto</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="name"
                  type="text"
                  name="nombre"
                  v-model="event.nombre"
                />
                <p v-if="errors.name" class="text-red-500 text-xs italic">
                  Escriba un nombre para el proyecto.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="objetivo"
                  >Objetivos</label
                >
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="objetivo"
                  type="text"
                  name="objetivo"
                  v-model="event.objetivo"
                />
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="especificaciones_multimedia"
                  >Especificaciones multimedia</label
                >
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="especificaciones_multimedia"
                  type="text"
                  name="especificaciones_multimedia"
                  v-model="event.especificaciones_multimedia"
                />
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="lider"
                  >Nombre de quien propone</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="lider"
                  type="text"
                  name="lider"
                  v-model="event.lider"
                />
                <p v-if="errors.lider" class="text-red-500 text-xs italic">
                  Escriba el nombre de quien propone.
                </p>
              </div>
            </div>

            <div class="w-full">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="esInstitucion"
                >¿Pertenece a una institución ?</label
              >
              <div class="relative">
                <select
                  v-model="event.es_institucion_option"
                  name="esInstitucion"
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  v-on:change="event.institucion = null"
                >
                  <option disabled selected>Seleccione una opción</option>
                  <option value="1">Si</option>
                  <option value="0">No</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div
              class="flex flex-wrap -mx-3 mb-6"
              v-if="event.es_institucion_option == '1'"
            >
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="institucion"
                  >institucion</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="institucion"
                  type="text"
                  name="institucion"
                  v-model="event.institucion"
                  :disabled="event.es_institucion_option == 0"
                />
                <p
                  v-if="errors.institucion"
                  class="text-red-500 text-xs italic"
                >
                  Escriba una institucion.
                </p>
              </div>
            </div>

            <div class="w-full mb-6">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                >Visibilidad del proyecto</label
              >
              <div class="flex w-full rounded-lg overflow-hidden border border-gray-300">
                <button
                  id="project-visibility-public"
                  type="button"
                  class="w-1/2 py-2 px-3 text-sm font-semibold transition-colors duration-200"
                  :class="!isPrivate ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                  @click="isPrivate = false"
                >
                  Público
                </button>
                <button
                  id="project-visibility-private"
                  type="button"
                  class="w-1/2 py-2 px-3 text-sm font-semibold transition-colors duration-200"
                  :class="isPrivate ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                  @click="isPrivate = true"
                >
                  Privado
                </button>
              </div>
              <p class="text-xs text-gray-600 mt-2 text-left">
                <span v-if="!isPrivate">Cualquier usuario podrá ver y participar en el proyecto desde la app.</span>
                <span v-else>Solo los usuarios asignados (y usted) verán el proyecto en la app móvil.</span>
              </p>

              <div v-if="isPrivate" class="mt-4">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Usuarios asignados ({{ assignedUsers.length }})</label
                >
                <multiselect
                  id="project-assigned-users"
                  v-model="assignedUsers"
                  :options="userOptions"
                  :multiple="true"
                  track-by="id"
                  :custom-label="userLabel"
                  :searchable="true"
                  :internal-search="false"
                  :loading="searchingUsers"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :preserve-search="true"
                  placeholder="Buscar por correo o nombre (mín. 2 letras)"
                  selectLabel="Seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Quitar"
                  @search-change="searchUsers"
                >
                  <span slot="noOptions">Escriba para buscar usuarios</span>
                  <span slot="noResult">Sin coincidencias</span>
                </multiselect>
              </div>
            </div>

            <!-- <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="description"
                  >Descripción</label
                >
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="description"
                  type="text"
                  name="descripcion"
                  v-model="event.descripcion"
                />
              </div>
            </div> -->

            <!-- <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="producto"
                  >Producto</label
                >
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="producto"
                  type="text"
                  name="producto"
                  v-model="event.producto"
                />
              </div>
            </div> -->

            <!-- <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Subir un archivo kml o kmz</label>
                <input type="file" ref="fileInput" name="kml_file" @change="loadTextFromFile" accept=".kml, .kmz">
              </div>
            </div> -->
            <div class="w-full px-3 mb-6">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                >Ficha de información</label
              >
              <div class="flex w-full">
                <btn-action
                  class="px-4 py-2 text-center rounded-lg text-white tracking-wide"
                  @click="showProjectQuestBuilder = true"
                  :colorT="colorT"
                >
                  Generar ficha
                </btn-action>
              </div>
            </div>

<!--             <div class="w-full px-3 mb-6">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="route"
                >ÁREA DEL PROYECTO (OPCIONAL) <br />
              </label>

              <template>
                <div>
                  <multiselect
                    v-model="municipioSelected"
                    :multiple="true"
                    placeholder="Seleccione uno o varios municipios"
                    label="labeledomun"
                    track-by="municipio"
                    selectLabel="Seleccionar"
                    selectedLabel="Seleccionado"
                    deselectLabel="Deseleccionar"
                    :options="municipios"
                  >
                    <span slot="noOptions">No hay opciones</span>
                    <span slot="noResult">Sin coincidencias</span>
                  </multiselect>
                </div>
              </template> -->
              <!-- <div class="h-96 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :maxZoom="maxZoom"
                  :center="center"
                  :options="{ zoomControl: true }"
                  @ready="onMapReady"
                >
                  <l-geo-json :geojson="geojsonRouter" :options="optionsKml" />
                  <l-tile-layer
                    :url="urlBasemap"
                    :attribution="attribution"
                  ></l-tile-layer>
                </l-map>
              </div> -->
            <!-- </div> -->

            <div class="flex w-full sticky bottom-0 justify-end py-5 bg-white">
              <btn-action
                class="px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="showingProjectConfirm = true"
                :colorT="colorT"
              >
                Guardar
              </btn-action>
              <button
                class="ml-2 bg-red-700 px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="close()"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>

      <alert-dialog :showing="showingProjectConfirm">
        <div class="flex items-center justify-center">
          <div class="uppercase text-gray-900">
            El proyecto se guardar sin mandar a revisión
          </div>
        </div>
        <div class="w-full flex items-center justify-center">
          <button
            class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
            @click="saveEvent()"
          >
            Aceptar
          </button>
          <button
            class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
            @click="showingProjectConfirm = false"
          >
            Cancelar
          </button>
        </div>
      </alert-dialog>

      <project-question-builder
        :showing="showProjectQuestBuilder"
        @close="closeProjectQuestBuilder"
        :questions="questions"
        @save="saveProjectQuestion"
        :modalAction="modalAction"
        :colorP="colorP"
        :colorS="colorS"
        :colorT="colorT"
      ></project-question-builder>
    </div>
  </Transition>
</template>

<script>
import { LMap, LGeoJson, LTileLayer } from "vue2-leaflet";
import LDraw from "leaflet-draw";
import * as esri from "esri-leaflet";
import "leaflet-kml/L.KML";
import "leaflet-kmz/dist/leaflet-kmz";
import tj from "@mapbox/togeojson";
import AlertDialog from "./AlertDialog";
import drawLocales from "leaflet-draw-locales";
import Multiselect from "vue-multiselect";

import ProjectQuestionBuilder from "./ProjectQuestionBuilder";

import { styled } from "@egoist/vue-emotion";

drawLocales("es");

const DivTitle = styled("div")`
  color: ${props => props.colorP};
`;

const BtnAction = styled("button")`
  background-color: ${props => props.colorT};
`;

export default {
  name: "project-modal",
  data() {
    return {
      municipios: [],
      municipioSelected: [],
      esInstitucion: null,
      isPrivate: false,
      assignedUsers: [],
      userOptions: [],
      searchingUsers: false,
      searchTimer: null,
      kmzParser: null,
      drawControl: null,
      drawControlEditOnly: null,
      showingProjectConfirm: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
          "Content-Type": "multipart/form-data"
        }
      },
      imageURL: "",
      image: null,
      url: "",
      errors: {
        name: false,
        institucion: false,
        lider: false,
        codeError: "Ha ocurrido un error"
      },
      // maxBounds: [
      //   [19.395295944890695, -99.22922388422747],
      //   [19.43212847837641, -99.17403475153704]
      // ],
      zoom: 7,
      maxZoom: 18,
      center: [20.58651, -89.01501],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      eventRoute: null,
      geojsonRouter: null,
      new_kml: null,
      map: null,
      layerKml: null,
      layerKmz: null,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showProjectQuestBuilder: false,
      questions: [],
      editQuestions: false,
      configResize: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    event: {
      required: true
    },
    aux_event: {
      required: true
    },
    modalAction: {
      required: true
    },
    colorP: {
      required: true
    },
    colorS: {
      required: true
    },
    colorT: {
      required: true
    }
  },
  components: {
    LMap,
    LGeoJson,
    LTileLayer,
    ProjectQuestionBuilder,
    AlertDialog,
    Multiselect,
    DivTitle,
    BtnAction
  },
  watch: {
    showing(value) {
      if (value) {
        if (this.modalAction === "edit") {
          7;
          this.municipioSelected = this.event.lista_municipios;
          this.imageURL = this.event.path_media_folder;
          let questions = JSON.parse(this.event.ficha_proyecto);
          let parsedQuestions = this.parseQuestions(questions);
          this.questions = parsedQuestions;
          this.isPrivate = !!this.event.es_privada;
          this.fetchAssignedUsers();
        }
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    this.fetchMunicipios();
  },
  methods: {
    authHeaders() {
      return { headers: { "x-access-token": localStorage.getItem("accessToken") } };
    },
    userLabel(user) {
      const name = [user.nombre, user.apellido].filter(Boolean).join(" ");
      return name ? `${name} (${user.email})` : user.email;
    },
    searchUsers(query) {
      clearTimeout(this.searchTimer);
      if (!query || query.trim().length < 2) {
        this.userOptions = [];
        return;
      }
      this.searchTimer = setTimeout(() => {
        this.searchingUsers = true;
        this.axios
          .post("../apidev/projects/searchUsers", { q: query }, this.authHeaders())
          .then(response => {
            this.userOptions = response.data.usuarios;
          })
          .catch(error => this.catchError(error))
          .finally(() => {
            this.searchingUsers = false;
          });
      }, 300);
    },
    fetchAssignedUsers() {
      this.assignedUsers = [];
      if (!this.event || !this.event.id) return;
      this.axios
        .get("../apidev/projects/assignedUsers/" + this.event.id, this.authHeaders())
        .then(response => {
          this.assignedUsers = response.data.usuarios;
        })
        .catch(error => this.catchError(error));
    },
    syncAssignedUsers(projectId) {
      // En alta de un proyecto público no hay nada que sincronizar
      if (!projectId || (!this.isPrivate && this.modalAction === "add")) {
        return Promise.resolve();
      }
      const user_ids = this.isPrivate ? this.assignedUsers.map(u => u.id) : [];
      return this.axios.put(
        "../apidev/projects/assignedUsers/" + projectId,
        { user_ids },
        this.authHeaders()
      );
    },
    fetchMunicipios() {
      this.$root.$emit("showLoading");
      this.axios
        .get("apidev/miapptsil/getMunicipiosActivos", {}, this.config)
        .then(response => {
          // removed console log
          this.municipios = response.data.municipios;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    loadTextFromFile(ev) {
      this.resetFileGeometryInMap();

      const file = ev.target.files[0];
      const fileType = file ? file.type : "";
      const reader = new FileReader();

      reader.onload = e => {
        const nameType = file.name.split(".").slice(-1)[0];

        switch (nameType) {
          //case "application/vnd.google-earth.kmz":
          case "kmz":
            let url = URL.createObjectURL(file);
            this.loadkmz(url);
            break;
          //case "application/vnd.google-earth.kml+xml":
          case "kml":
            this.loadKml(e.target.result);
            break;
          default:
            break;
        }
      };
      if (file) {
        reader.readAsText(file);
      }
    },
    loadkmz(url) {
      this.kmzParser.load(url);
    },
    loadKml(text) {
      if (this.map != null) {
        this.resetFileGeometryInMap();

        if (this.eventRoute !== null) {
          this.map.removeLayer(this.eventRoute);
          this.eventRoute = null;
          this.map.removeControl(this.drawControlEditOnly);
          this.drawControl.addTo(this.map);
        }

        const parser = new DOMParser();
        this.new_kml = parser.parseFromString(text, "text/xml");
        let converted = tj.kml(this.new_kml, { styles: true });

        this.layerKml = new L.KML(this.new_kml);
        this.map.addLayer(this.layerKml);
        //this.geojsonRouter = this.layerKml.toGeoJSON();
        //this.geojsonRouter = converted
        //this.geojsonRouter = null;
      }
    },
    onMapReady: function () {
      this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        this.map = this.$refs.map.mapObject;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function (layer, name) {
            that.resetFileGeometryInMap();

            if (that.eventRoute !== null) {
              map.removeLayer(that.eventRoute);
              that.eventRoute = null;
              map.removeControl(that.drawControlEditOnly);
              that.drawControl.addTo(map);
            }

            that.layerKmz = layer;
            layer.addTo(map);
          }
        });

        //esri.basemapLayer("Topographic").addTo(map);
        const editableLayers = new window.L.FeatureGroup().addTo(map);
        this.drawControl = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: {
              allowIntersection: false
            },
            polygon: {
              showArea: true,
              showLength: true
            },
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          }
        });

        this.drawControlEditOnly = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: false,
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          },
          edit: {
            featureGroup: editableLayers
          }
        });

        if (this.modalAction === "edit" && this.event.geometria !== null) {
          if (this.event.geometria.type != "FeatureCollection") {
            const routeLayer = window.L.GeoJSON.geometryToLayer(
              this.event.geometria
            );
            this.eventRoute = routeLayer;
            if (this.eventRoute) {
              let boundingBoxGeojson = L.geoJSON(this.event.geometria);
              let boundingBox = boundingBoxGeojson.getBounds();
              this.$refs.map.mapObject.fitBounds(boundingBox);
            }
            routeLayer.addTo(editableLayers);
            map.addControl(this.drawControlEditOnly);
          } else {
            if (this.event.kml != null) {
              let type = this.event.kml.split(".")[1];
              if (type == "kml") {
                this.layerKml = this.event.geometria;
                this.geojsonRouter = null;

                var oReq = new XMLHttpRequest();
                oReq.addEventListener("load", () => {
                  this.loadKml(oReq.responseText);
                });
                oReq.open("GET", "../apidev/" + this.event.kml);
                oReq.send();
              }
              if (type == "kmz") {
                this.kmzParser.load("../apidev/" + this.event.kml);
              }
            }
            map.addControl(this.drawControl);
          }
        } else {
          map.addControl(this.drawControl);
        }

        map.on("draw:drawstart", e => {
          //this.$refs.fileInput.value = null;
          this.resetFileGeometryInMap();
        });

        map.on("draw:created", e => {
          let layer = e.layer;
          this.eventRoute = layer;
          layer.addTo(editableLayers);
          map.removeControl(this.drawControl);
          this.drawControlEditOnly.addTo(map);
        });

        map.on("draw:edited", e => {
          let layers = e.layers;
          layers.eachLayer(layer => {
            this.eventRoute = layer;
          });
        });

        map.on("draw:deleted", e => {
          this.eventRoute = null;
          map.removeControl(this.drawControlEditOnly);
          this.drawControl.addTo(map);
        });
      });
    },
    resetFileGeometryInMap() {
      if (this.layerKml != null) {
        this.map.removeLayer(this.layerKml);
        this.geojsonRouter = null;
        this.layerKml = null;
      }

      if (this.layerKmz != null) {
        this.map.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }
    },
    reset: function () {
      this.errors = {
        name: false,
        institucion: false,
        lider: false,
        codeError: "Ha ocurrido un error"
      };
      this.esInstitucion = null;
      this.imageURL = "";
      this.url = "";
      this.geojsonRouter = null;
      this.layerKml = null;
      this.layerKmz = null;
      this.questions = [];
      this.editQuestions = false;
      this.isPrivate = false;
      this.assignedUsers = [];
      this.userOptions = [];
    },
    close() {
      this.reset();
      this.$emit("close", "dismiss");
    },
    //Cambiar el this.event a formData
    saveEvent() {
      const form = document.getElementById("proyectForm");
      const formData = new FormData(form);
      const validForm = this.checkFormEvent(formData);
      let projectImgName = "";
      this.showingProjectConfirm = false;

      if (validForm) {
        const event_image = formData.get("image");
        const event_kml = formData.get("kml_file");
        const mimeType = this.checkMimeType(event_image);
        const newDate = Date.now();

        if (event_image && event_image.name != "") {
          let name = this.event.nombre.replace(/\s+/g, "_");
          projectImgName = name + "_" + newDate + mimeType;
          formData.set("image", event_image, projectImgName);
        }

        if (event_kml && event_kml.name != "") {
          const mimeTypeGeometry = this.checkMimeTypeGeometry(event_kml);
          let name = this.event.nombre.replace(/\s+/g, "_");
          formData.set(
            "kml_file",
            event_kml,
            name + "_" + newDate + mimeTypeGeometry
          );
        }

        formData.append("id_propietario", localStorage.getItem("user_id"));
        formData.append("municipios", JSON.stringify(this.municipioSelected));
        if (this.isPrivate) {
          formData.set("isPrivate", "true");
        } else {
          formData.delete("isPrivate");
        }

        if (this.eventRoute !== null) {
          formData.append(
            "geometria",
            JSON.stringify(this.eventRoute.toGeoJSON())
          );
          formData.append("type", "draw");
        }

        if (this.layerKml !== null) {
          formData.append(
            "geometria",
            JSON.stringify(this.layerKml.toGeoJSON())
          );
          formData.append("type", "file");
          //formData.append("route", JSON.stringify(tj.kml(this.new_kml,  { styles: true })));
        }

        if (this.layerKmz !== null) {
          formData.append(
            "geometria",
            JSON.stringify(this.layerKmz.toGeoJSON())
          );
          formData.append("type", "file");
        }

        this.clearQuestionsData();

        formData.append("ficha_proyecto", JSON.stringify(this.questions));

        if (this.modalAction === "add") {
          this.axios
            .post("../apidev/projects/newProject", formData, this.config)
            .then(response => {
              const proyecto = response.data && response.data.proyecto;
              return this.syncAssignedUsers(proyecto ? proyecto.id : null);
            })
            .then(() => {
              if (projectImgName !== "") {
                this.axios
                  .post(
                    "../apidev/projects/saveResize",
                    { fileName: projectImgName },
                    this.configResize
                  )
                  .then(() => {
                    this.reset();
                    this.$emit("close");
                  })
                  .catch(error => {
                    this.catchError(error);
                    this.showingError = true;
                  });
              } else {
                this.reset();
                this.$emit("close");
              }
            })
            .catch(error => {
              this.catchError(error);
              this.showingError = true;
            });
        } else {
          if (this.modalAction === "edit") {
            this.axios
              .put(
                "../apidev/projects/updateProject/" + this.event.id,
                formData,
                this.config
              )
              .then(() => this.syncAssignedUsers(this.event.id))
              .then(() => {
                this.reset();
                this.$emit("close");
              })
              .catch(error => {
                this.catchError(error);
                this.showingError = true;
              });
          }
        }
      }
    },
    changeImage: function (event) {
      let file = event.target.files[0];
      this.imageURL = URL.createObjectURL(file);
      this.image = this.$refs.image.files[0];
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },

    checkMimeTypeGeometry(file) {
      let mimeType = "";
      const nameType = file.name.split(".").slice(-1)[0];

      switch (nameType) {
        //case "application/vnd.google-earth.kmz":
        case "kmz":
          mimeType = ".kmz";
          break;
        //case "application/vnd.google-earth.kml+xml":
        case "kml":
          mimeType = ".kml";
          break;
        default:
          break;
      }
      return mimeType;
    },
    checkFormEvent: function (data) {
      if (data.get("nombre") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("institucion") === "") {
        this.errors.institucion = true;
      } else {
        this.errors.institucion = false;
      }

      if (data.get("lider") === "") {
        this.errors.lider = true;
      } else {
        this.errors.lider = false;
      }

      if (this.errors.name || this.errors.institucion || this.errors.lider) {
        return false;
      }

      return true;
    },
    loadDefaultImg(event) {
      event.target.src = "https://placehold.co/200?text=Imagen";
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    },
    closeProjectQuestBuilder(backupQuestions) {
      if (!this.editQuestions) {
        if (this.modalAction !== "edit") {
          this.questions = [];
        } else {
          this.questions = backupQuestions;
        }
      }

      this.showProjectQuestBuilder = false;
    },
    saveProjectQuestion() {
      this.editQuestions = true;
      this.showProjectQuestBuilder = false;
    },
    clearQuestionsData() {
      if (!this.questions || !Array.isArray(this.questions)) return;
      this.questions.forEach(question => {
        switch (question.tipo) {
          case "ABIERTA":
            delete question.error;

            question.subpregunta.forEach(subpregunta => {
              switch (subpregunta.tipo) {
                case "ABIERTA":
                  delete subpregunta.error;
                  break;
                case "SELECCION":
                  delete subpregunta.error;
                  delete subpregunta.optionError;
                  delete subpregunta.minimumError;
                  delete subpregunta.maximumOptionError;
                  break;
                case "CAMPOS":
                  delete subpregunta.error;
                  delete subpregunta.fieldError;
                  delete subpregunta.minimumError;
                  break;
                default:
                  break;
              }
            });
            break;
          case "SELECCION":
            delete question.error;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumOptionError;
            delete question.maximumSubquestionError;
            break;
          case "CAMPOS":
            delete question.error;
            delete question.fieldError;
            delete question.minimumError;
            break;
          case "OPCION_SEGUIMIENTO":
            delete question.error;
            delete question.conceptoError;
            delete question.conceptoMinError;
            delete question.subTipoError;
            delete question.subOptionError;
            delete question.subMinError;
            break;
          case "SELECCION_CONDICIONAL": {
            delete question.error;
            delete question.errorCond;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumError;
            delete question.duplicateError;
            delete question.maximumOptionError;

            let pregunta_condicion = {};

            question.preguntas_condicion.forEach(condQuestion => {
              switch (condQuestion.tipo) {
                case "ABIERTA": {
                  delete condQuestion.error;
                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                case "SELECCION": {
                  delete condQuestion.error;
                  delete condQuestion.optionError;
                  delete condQuestion.minimumError;
                  delete condQuestion.maximumOptionError;

                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                case "CAMPOS": {
                  delete condQuestion.error;
                  delete condQuestion.fieldError;
                  delete condQuestion.minimumError;

                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                default:
                  break;
              }
            });

            delete question.preguntas_condicion;

            question.pregunta_condicion = pregunta_condicion;
            break;
          }
          case "FECHA":
            delete question.error;
            break;
          default:
            break;
        }
      });
    },
    parseQuestions(questions) {
      if (!questions || !Array.isArray(questions)) return [];
      questions.forEach(question => {
        switch (question.tipo) {
          case "ABIERTA":
            question.error = false;
            break;
          case "SELECCION":
            question.error = false;
            question.optionError = false;
            question.minimumError = false;
            break;
          case "CAMPOS":
            question.error = false;
            question.fieldError = false;
            question.minimumError = false;
            break;
          case "SELECCION_CONDICIONAL": {
            question.error = false;
            question.errorCond = false;
            question.optionError = false;
            question.minimumError = false;
            question.maximumError = false;
            question.duplicateError = false;

            let preguntas_condicion = [];
            for (let key in question.pregunta_condicion) {
              let pregunta_condicion = question.pregunta_condicion[key];
              switch (pregunta_condicion.tipo) {
                case "ABIERTA":
                  pregunta_condicion.error = false;

                  pregunta_condicion.assignment = key;
                  pregunta_condicion.assignmentError = false;

                  preguntas_condicion.push(pregunta_condicion);
                  break;
                case "SELECCION":
                  pregunta_condicion.error = false;
                  pregunta_condicion.optionError = false;
                  pregunta_condicion.minimumError = false;

                  pregunta_condicion.assignment = key;
                  pregunta_condicion.assignmentError = false;

                  preguntas_condicion.push(pregunta_condicion);
                  break;
                case "CAMPOS":
                  pregunta_condicion.error = false;
                  pregunta_condicion.fieldError = false;
                  pregunta_condicion.minimumError = false;

                  pregunta_condicion.assignment = key;
                  pregunta_condicion.assignmentError = false;

                  preguntas_condicion.push(pregunta_condicion);
                  break;
                default:
                  break;
              }
            }

            question.preguntas_condicion = preguntas_condicion;
            break;
          }
          case "OPCION_SEGUIMIENTO":
            question.error = false;
            break;
          case "FECHA":
            question.error = false;
            break;
          default:
            break;
        }
      });

      return questions;
    }
  },
  computed: {
    optionsKml() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    onEachFeatureFunction() {
      return (feature, layer) => {
        layer
          .bindTooltip(
            `
            <div>
            ${feature.properties.description}
            </div>
          `
          )
          .openTooltip();
      };
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
